// /dashboard/:orgSlug/support — Figma frame 22 contact support (33:1238).
// Owner: screens-ops, US-132.

import { createRoute } from "@tanstack/react-router";
import { shellRoute } from "./_shell";
import { SupportScreen } from "../screens/ops/SupportScreen";

export const supportRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: "/dashboard/$orgSlug/support",
  staticData: { title: "Support" },
  component: SupportRoute,
});

function SupportRoute() {
  const { orgSlug } = supportRoute.useParams();
  return (
    <SupportScreen orgSlug={orgSlug} />
  );
}
